var _circle, _path, _path2, _rect, _rect2, _path3, _rect3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarwars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    fill: "#000000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 5c-2 0-10 7-10 20 0 8 3 15 10 20 7-5 10-12 10-20 0-13-8-20-10-20z",
    fill: "#FFE81F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25c0-12 7-18 9-18-2 0-9 6-9 18 0 7 3 13 9 18-6-5-9-11-9-18zm18 0c0-12-7-18-9-18 2 0 9 6 9 18 0 7-3 13-9 18 6-5 9-11 9-18z",
    fill: "#000"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 16,
    width: 6,
    height: 2,
    fill: "#000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 20,
    width: 6,
    height: 2,
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 30c-3 0-5-1-5-3h10c0 2-2 3-5 3z",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 34,
    width: 8,
    height: 2,
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 28h8l-1 6h-6z",
    fill: "#000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28 28h-6l-1 6h8z",
    fill: "#FF0000",
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarwars);
export default __webpack_public_path__ + "static/media/starwars.64c632d335a239570749c56fec4e9188.svg";
export { ForwardRef as ReactComponent };